import { render, staticRenderFns } from "./QuotationDetail.vue?vue&type=template&id=611eefc4&scoped=true&"
import script from "./QuotationDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetail.vue?vue&type=style&index=0&id=611eefc4&prod&lang=scss&scoped=true&"
import style1 from "./QuotationDetail.vue?vue&type=style&index=1&id=611eefc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611eefc4",
  null
  
)

export default component.exports